/**
 * Pure parsing of the composer text into the active menu query, if any.
 * A slash command (`/foo`) or mention (`@foo`) can start after whitespace at
 * the active end of the draft. Skills keep their whole-input behaviour.
 */

const trailingCommandPattern = /(?:^|\s)\/([^\s/]*)$/;

/** Lowercased trailing slash-command query (text after `/`), or null. */
export function parseCommandQuery(text: string): string | null {
  return text.match(trailingCommandPattern)?.[1]?.toLowerCase() ?? null;
}

/** Replaces only the active trailing `/query`, preserving the rest of the draft. */
export function replaceCommandQuery(text: string, replacement: string): string {
  const match = text.match(trailingCommandPattern);
  if (match === null) return text;
  const query = match[1] ?? '';
  return `${text.slice(0, text.length - query.length - 1)}${replacement}`;
}

/** Lowercased skill query (text after `$`), or null. */
export function parseSkillQuery(text: string): string | null {
  return /^\$[^\s]*$/.test(text) ? text.slice(1).toLowerCase() : null;
}

/** Lowercased mention query (text after a trailing `@token`), or null. */
export function parseMentionQuery(text: string): string | null {
  return text.match(/(?:^|\s)@([^\s@]*)$/)?.[1]?.toLowerCase() ?? null;
}

/** Replaces only the active trailing `@query`, preserving the rest of the draft. */
export function replaceMentionQuery(text: string, replacement: string): string {
  const match = text.match(/(?:^|\s)@([^\s@]*)$/);
  if (match === null) return text;
  const query = match[1] ?? '';
  return `${text.slice(0, text.length - query.length - 1)}${replacement}`;
}
